import React, { useEffect, useState } from 'react';

export const MarketingKit = () => {
  const [assets,   setAssets]   = useState([]);
  const [captions, setCaptions] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState('');
  const [copied,   setCopied]   = useState(null);
 
  useEffect(() => {
    import('./resellerapi').then(({ marketingAPI }) => {
      Promise.all([marketingAPI.getAssets(), marketingAPI.getCaptions()])
        .then(([a, c]) => { setAssets(a.data || []); setCaptions(c.data || []); })
        .catch(e => setError(e.message))
        .finally(() => setLoading(false));
    });
  }, []);
 
  const copyCaption = async (text, id) => {
    await navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  };
 
  return (
    <div>
      {error && <div className="res-error">{error}</div>}
 
      <div className="res-card" style={{ marginBottom: '1.5rem' }}>
        <div className="res-card-title">Promotion Assets</div>
        {loading ? (
          <div className="kit-assets-grid">
            {[...Array(3)].map((_, i) => (
              <div key={i}>
                <div className="skeleton" style={{ height: 160 }} />
                <div style={{ padding: '0.75rem' }}>
                  <div className="skeleton" style={{ height: 13, width: '60%', marginBottom: 8 }} />
                  <div className="skeleton" style={{ height: 30 }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="kit-assets-grid">
            {assets.map(a => (
              <div key={a.id} className="kit-asset-card">
                <div className="kit-asset-thumb">
                  <img
                    src={a.thumbnail || `https://atrmart.in/storage/${a.file_path}`}
                    alt={a.title}
                    onError={e => { e.target.src = 'https://via.placeholder.com/240x160?text=Asset'; }}
                  />
                  <span className="kit-asset-type">{a.type?.toUpperCase()}</span>
                </div>
                <div className="kit-asset-info">
                  <div className="kit-asset-name">{a.title}</div>
                  <div className="kit-asset-size">{a.dimensions || a.file_size}</div>
                  <a
                    href={`https://atrmart.in/storage/${a.file_path}`}
                    download
                    className="kit-download-btn"
                    style={{ textDecoration: 'none' }}
                  >
                    ⬇ Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
 
      <div className="captions-section">
        <div className="res-card-title" style={{ marginBottom: '1rem' }}>
          Ready-to-send WhatsApp Captions
        </div>
        {captions.map(c => (
          <div key={c.id} className="caption-item">
            <p className="caption-text">{c.text}</p>
            <button
              className={`caption-copy-btn ${copied === c.id ? 'copied' : ''}`}
              onClick={() => copyCaption(c.text, c.id)}
            >
              {copied === c.id ? '✓ Copied!' : '📋 Copy'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
 
export default MarketingKit;